import apiClient from "@/axios";

export const getPackageWithOutFree = async () => {
  const response = await apiClient.post("/user/package/get-package-with-out-free");
  return response;
};

export const setPackage = async (packageId) => {
  const response = await apiClient.post("/user/package/set-package", {
    packageId: packageId,
  });
  return response;
};

export const getUserPackages = async () => {
  const response = await apiClient.post("/user/package/get-user-packages");
  return response;
};

export const getActiveUserPackage = async () => {
  const response = await apiClient.post("/user/package/get-active-user-package");
  return response;
};